import { render } from "./NoVideo.vue?vue&type=template&id=0e516c23&ts=true"
import script from "./NoVideo.vue?vue&type=script&lang=ts"
export * from "./NoVideo.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__